import messages from '../components/language'

export const cI18n = (text)=>{
  let lang = "en"
  if(window.origin.includes("sflow.pro") || window.origin.includes("saasflow.cn")){
    lang = 'zh'
  }

  try {
    if(typeof text !== 'string') throw text
    const textArr = text.split('.')
    let resultText = messages[lang]
    for (let index = 0; index < textArr.length; index++) {
      const textItem = textArr[index];
      if(resultText[textItem]){
        resultText = resultText[textItem]
      }else{
        throw text
      }
    }
    return resultText
  } catch (error) {
    return text
  }
}